export default __webpack_public_path__ + "static/media/Atharva.47fe369f.jpeg";